import type { FC } from 'react';

import { HelpText } from '@pp/core/src/services/helpTranslations/reactBindings/HelpText';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';

import { HIGHFLYER_PT } from '../../../config';

export const HelpChapterCrashDisconnectionPolicy: FC = () => {
  const tableVariant = useConfigSlice.getTableVariant();

  return (
    <div>
      <p>
        <HelpText tk="disconnectionPolicy.disconnection" />
      </p>
      <ul>
        <li>
          <HelpText tk="disconnectionPolicy.disconnectionBefore" markdown />
        </li>
        <li>
          <HelpText tk="disconnectionPolicy.disconnectionAfter" markdown />
        </li>
        <li>
          <HelpText tk="disconnectionPolicy.forcedCashout" markdown />
        </li>
      </ul>
      <p>
        <HelpText tk="disconnectionPolicy.contactSupport" markdown />
      </p>
      {tableVariant === HIGHFLYER_PT ? null : (
        <p>
          <HelpText tk="disconnectionPolicy.policyNotApplyWithoutCashout50" />
        </p>
      )}
      <p>
        <HelpText tk="disconnectionPolicy.contactCustomerSupport" />
      </p>
    </div>
  );
};
